module.exports = __webpack_public_path__ + "static/media/error.a0316582.mp3";